import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { ControlContainer, FormArray, FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common'

// import { config } from 'src/app/valueObject/config';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';
import { Title, disableDebugTools } from '@angular/platform-browser';
import { toWords } from 'src/app/shared/toWords';
import { NgxSpinnerService } from 'ngx-spinner';
import readXlsxFile, { Schema } from 'read-excel-file';
import convertToJson from 'read-excel-file/map';
import writeXlsxFile from 'write-excel-file';
import { CustomValidators } from 'src/app/shared/customValidators';
import { style } from '@angular/animations';
declare var $: any;


@Component({
  selector: 'app-amrt-acrt-schedule',
  templateUrl: './amrt-acrt-schedule.component.html',
  styleUrls: ['./amrt-acrt-schedule.component.css'],
  viewProviders: [{
    provide: ControlContainer, useExisting: FormGroupDirective
  }]
})
export class AmrtAcrtScheduleComponent implements OnInit, OnChanges, AfterViewInit {
  amrtAcrtScheduleList: FormArray;
  message: string;
  paymentScheduleData: any = [];
  dtTrigger: Subject<any> = new Subject<any>();
  dtOptions: any;
  amrtAcrtForm: FormGroup;
  fileupload: FormGroup;
  toWords = toWords;
  exchangeTypeArray: any = ['AMRT', 'ACRT'];
  bsValue: any = [];
  bsValue1: any = [];
  fileName: string;
  file: File;
  isFileUploaded: boolean = false;
  amrtAcrtMap: any = {};
  errorArray: any = [];
  amrtFormArrayName: string = '';

  @Input()
  formType: string;

  @Input()
  irsFormData: any = [];

  @Input()
  action: string;

  @Input() dropdownData: any;

  @Output() formUpdate = new EventEmitter<{ formData: FormArray }>();

  @ViewChild('file', { static: false })
  fileInput: ElementRef;

  constructor(private fb: FormBuilder,
    private toastr: ToastrService,
    private cdref: ChangeDetectorRef,
    private datePipe: DatePipe,
    public fgd: FormGroupDirective,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    // this.paymentScheduleData = [
    //   {
    //     notionalCrncyOutAmt: '100000',
    //     notionalCrncyPymntAmt: '100000',
    //     paymentDate: new Date(),
    //     type: 'AMRT'
    //   },
    //   {
    //     notionalCrncyOutAmt: '100000',
    //     notionalCrncyPymntAmt: '100000',
    //     paymentDate: new Date(),
    //     type: 'ACRT'
    //   }
    // ]
    this.amrtAcrtForm = this.fb.group({
      scheduleType: ['autoGenerate'],
      filetype: ['', Validators.required]
    })

    this.amrtAcrtScheduleList = this.fb.array([]);
    // let paymentScheduleArray = <FormArray>this.amrtAcrtScheduleList;
    // this.paymentScheduleData.forEach(element => {
    //   paymentScheduleArray.push(this.fb.group({
    //     notionalCrncyOutAmt: [element.notionalCrncyOutAmt],
    //     notionalCrncyPymntAmt: [element.notionalCrncyPymntAmt],
    //     paymentDate: [element.paymentDate],
    //     type: [element.type]
    //   }))
    // });
    // this.amrtAcrtScheduleList = paymentScheduleArray;

  }

  ngAfterViewInit(): void {
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.formType == 'amrtAcrtScheduleList') {
      this.amrtAcrtMap = {
        'ID': { prop: 'amrtAcrtSheduleId', type: String, required: false, oneOf: null, fieldType: 'text', disabled: null },
        'Notional Currency Total Outstanding Amount': { prop: 'notionalCrncyOutAmt', type: Number, required: true, oneOf: null, fieldType: 'number', disabled: null },
        'Notional Currency Repayment Amount': { prop: 'notionalCrncyPymntAmt', type: Number, required: true, oneOf: null, fieldType: 'number', disabled: null },
        'Payment Date': { prop: 'paymentDate', type: Date, required: true, oneOf: null, fieldType: 'date', disabled: null },
        'AMRT/ACRT Type': { prop: 'type', type: String, required: true, oneOf: ['AMRT', 'ACRT'], fieldType: 'select', disabled: this.fgd.form.controls.addtnlFeature.value == 'AMRT' ? true : null }
      }
    } else if (this.formType == 'fixedPaymentSchedule') {
      this.amrtAcrtMap = {
        'ID': { prop: 'paymentId', type: String, required: false, oneOf: null, fieldType: 'text', disabled: null },
        'Payment Date': { prop: 'paymentDate', type: Date, required: true, oneOf: null, fieldType: 'date', disabled: null }
      }
    } else if (this.formType == 'floatPaymentSchedule') {
      this.amrtAcrtMap = {
        'ID': { prop: 'irsIntrstPayId', type: String, required: false, oneOf: null, fieldType: 'text', disabled: null },
        'Payment Date': { prop: 'paymentDate', type: Date, required: true, oneOf: null, fieldType: 'date', disabled: null },
        'Reset Date': { prop: 'resetDate', type: Date, required: true, oneOf: null, fieldType: 'date', disabled: null },
        'Benchmark': { prop: 'benchmark', type: String, required: true, oneOf: this.dropdownData.benchmarkList, fieldType: 'select', disabled: null },
        'Designated Maturity': { prop: 'designatedMaturity', type: String, required: true, oneOf: this.dropdownData.designatedMaturityList, fieldType: 'select', disabled: null },
        'Designated Maturity (In case of Stub)': { prop: 'designatedMaturityStub', type: String, required: true, oneOf: this.dropdownData.designatedMaturityList, fieldType: 'select', disabled: null },
        'Cap Rate': { prop: 'capRate', type: Number, required: true, oneOf: null, fieldType: 'number', disabled: null },
        'Floor Rate': { prop: 'floorRate', type: Number, required: true, oneOf: null, fieldType: 'number', disabled: null },
      }
    } else if (this.formType == 'recouponingDtls') {
      this.amrtAcrtMap = {
        'ID': { prop: 'recoupningId', type: String, required: false, oneOf: null, fieldType: 'text', disabled: null },
        'Recouponing Date': { prop: 'recoupngDate', type: Date, required: true, oneOf: null, fieldType: 'date', disabled: null },
        'Recouponing Rate': { prop: 'recoupngRate', type: Number, required: true, oneOf: null, fieldType: 'number', disabled: null },
      }
    }
    this.amrtAcrtForm = this.fb.group({
      scheduleType: ['autoGenerate'],
      filetype: ['', Validators.required]
    })


    this.paymentScheduleData = this.irsFormData || [];
    this.amrtAcrtScheduleList = this.fb.array([]);
    this.fgd.form.controls[this.formType] = this.amrtAcrtScheduleList;
    let paymentScheduleArray = <FormArray>this.fgd.form['controls'][this.formType];

    this.paymentScheduleData.forEach((element, index) => {
      let paymentFormGroup = this.fb.group({});
      for (let key in this.amrtAcrtMap) {
        let paymentControl;
        if (this.amrtAcrtMap[key].type == Date) {
          paymentControl = this.fb.control(element[this.amrtAcrtMap[key].prop] ? new Date(element[this.amrtAcrtMap[key].prop]) : null);
        } else if (this.amrtAcrtMap[key].type == Number) {
          paymentControl = this.fb.control(element[this.amrtAcrtMap[key].prop] || 0);
        } else {
          paymentControl = this.fb.control(element[this.amrtAcrtMap[key].prop] || null);
        }
        ///////////////////////////////////////note - in case of existing record, need to check id
        if (this.formType == 'amrtAcrtScheduleList' && this.fgd.form.controls.addtnlFeature.value == 'BOTH' && (this.amrtAcrtMap[key].prop == 'notionalCrncyOutAmt' || this.amrtAcrtMap[key].prop == 'notionalCrncyPymntAmt') && !element[this.amrtAcrtMap['ID'].prop]) {
          paymentControl.setValue('');
        }

        if (this.amrtAcrtMap[key].required) {
          paymentControl.addValidators(Validators.required);
        }
        if (this.amrtAcrtMap[key].type == Number) {
          paymentControl.addValidators(CustomValidators.allowOnlyNumberValidation);
        }
        if (this.amrtAcrtMap[key].disabled) {
          paymentControl.disable();
        }
        if (this.formType == 'amrtAcrtScheduleList' && this.amrtAcrtMap[key].prop == 'paymentDate' && index == 0) {
          paymentControl.disable();
        }
        paymentFormGroup.addControl(this.amrtAcrtMap[key].prop, paymentControl)
      }
      paymentScheduleArray.push(paymentFormGroup);
    });
    this.amrtAcrtScheduleList = paymentScheduleArray;
    this.fgd.form.controls[this.formType] = this.amrtAcrtScheduleList;
    this.fgd.form.controls[this.formType].updateValueAndValidity();
    if (this.action == 'reversal' || this.action == 'view') {
      this.fgd.form.controls[this.formType].disable();
    }
    this.fgd.form.updateValueAndValidity();
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
    this.formUpdateAmrt();
  }

  onChange(file) {
    this.file = file.files[0];
    this.fileName = file.files[0].name;
    this.isFileUploaded = true;
    readXlsxFile(this.file).then((rows) => {
      const data1: any = convertToJson(rows, this.amrtAcrtMap);
      console.log("row : ", data1.rows);
      if (data1.errors.length > 0) {
        this.errorArray = data1.errors;
      }
      this.paymentScheduleData = data1.rows;
      let paymentScheduleArray: FormArray;
      this.amrtAcrtScheduleList = this.fb.array([]);
      this.fgd.form.controls[this.formType] = this.amrtAcrtScheduleList;
      paymentScheduleArray = <FormArray>this.fgd.form['controls'][this.formType];

      this.paymentScheduleData.forEach((element, index) => {
        let paymentFormGroup = this.fb.group({});
        let paymentControl;
        for (let key in this.amrtAcrtMap) {
          if (key != 'ID') {
            if (this.amrtAcrtMap[key].type == Date) {
              paymentControl = this.fb.control(element[this.amrtAcrtMap[key].prop] ? new Date(element[this.amrtAcrtMap[key].prop]) : null);
            } else if (this.amrtAcrtMap[key].type == Number) {
              paymentControl = this.fb.control(element[this.amrtAcrtMap[key].prop] || 0);
            } else {
              paymentControl = this.fb.control(element[this.amrtAcrtMap[key].prop] || null);
            }

            if (this.amrtAcrtMap[key].required) {
              paymentControl.addValidators(Validators.required);
            }
            if (this.amrtAcrtMap[key].type == Number) {
              paymentControl.addValidators(CustomValidators.allowOnlyNumberValidation);
            }
            if (this.amrtAcrtMap[key].disabled) {
              paymentControl.disable();
            }
            paymentFormGroup.addControl(this.amrtAcrtMap[key].prop, paymentControl)
          }
        }
        paymentScheduleArray.push(paymentFormGroup);
      });
      this.amrtAcrtScheduleList = paymentScheduleArray;
      this.fgd.form.controls[this.formType] = this.amrtAcrtScheduleList;
      this.fgd.form.controls[this.formType].updateValueAndValidity();
      this.fgd.form.updateValueAndValidity();
      this.cdref.detectChanges();
      $('.selectpicker').selectpicker('refresh');
      this.formUpdateAmrt();

    })
  }

  formUpdateAmrt() {
    this.formUpdate.emit({ formData: <FormArray>this.fgd.form.controls[this.formType] });
  }

  getError(i, column) {
    if (!this.fgd.form.controls[this.formType]['controls'][i]) {
      console.log("form type: ", this.formType);
      console.log("index ", i);
      console.log("column ", column)
    }

    if (this.fgd.form.controls[this.formType]['controls'][i]['controls'][this.amrtAcrtMap[column].prop].value == null) {
      if (this.fgd.form.controls[this.formType]['controls'][i]['controls'][this.amrtAcrtMap[column].prop].hasValidator(Validators.required)) {
        return true;
      }
      return this.errorArray.find(e => (e.row == (i + 2) && e.column == column)) ? true : false;
    } else {
      return false;
    }
  }

  removeFile() {
    this.fileInput.nativeElement.value = null;
    this.isFileUploaded = false;
    this.file = null;
    this.fileName = '';
    this.cdref.detectChanges();
  }

  get f() {
    return this.amrtAcrtScheduleList.controls;
  }

  get af() {
    return this.amrtAcrtForm.controls;
  }

  showSchedule() {
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  async downloadExcelFile() {
    let headerData = [];
    for (let key in this.amrtAcrtMap) {
      if (key != 'ID') {
        headerData.push({ value: key })
      }
    }
    await writeXlsxFile([headerData], { fileName: 'AMRT_ACRT.xlsx', headerStyle: { fontWeight: 'bold', align: 'center', wrap: false } })
  }

  // setDatatable() {
  //   $("#paymentData").DataTable().destroy();
  //   setTimeout(() => {
  //     $("#paymentData").DataTable({
  //       processing: true,
  //       orderCellsTop: true,
  //       dom: "Brt",
  //       paging: false,
  //       buttons:
  //         [{
  //           extend: 'copy',
  //           titleAttr: 'Copy'
  //         }, {
  //           extend: 'excel',
  //           titleAttr: 'Export to excel'
  //         }, {
  //           extend: 'pdf',
  //           orientation: 'landscape',
  //           pageSize: 'A4',
  //           titleAttr: 'Download as PDF'
  //         }]
  //     });
  //     this.cdref.detectChanges();
  //     $('.selectpicker').selectpicker('refresh');
  //   }, 1);
  // }

  returnZero() {
    return 0;
  }

}
